import { createGlobalStyle } from "styled-components";
import { ThemeProps } from "../theme";

export const Styles = createGlobalStyle<ThemeProps>`

    @font-face {
        font-family: "Poppins Light";
        src: url("/fonts/Poppins-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Poppins Bold";
        src: url("/fonts/Poppins-Bold.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Poppins Regular";
        src: url("/fonts/Poppins-Regular.ttf") format("truetype");
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: ${props=>props.theme.fonts.light}, sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: ${props=>props.theme.fonts.bold}, sans-serif;
        color: ${({ theme }) => theme.colors.primary};
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p, li {
        color: ${({ theme }) => theme.colors.primary};
        font-size: 20px;        
    }

    a {
        text-decoration: none;
        outline: none;
        color: ${(props) => props.theme.colors.primary};
        :hover,
        :active,
        :focus {
            color: ${(props) => props.theme.colors.secondary};
            text-underline-position: under;
            text-decoration:${(props) =>
              props.theme.colors.secondary} wavy underline;
        }
    }
    b {
        font-family: ${(props) => props.theme.fonts.bold}, sans-serif
    }
    
    *:focus {
        outline: none;
    }
    *{
        box-sizing: border-box;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
